import React from 'react';

import {Stack, Typography, useTheme} from '@mui/material';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import {formatText} from 'presentation/utils';
import {useRequestAuthorization} from '../../hooks';
import {StyledButton, StyledStack} from './styles';
import {CurrentLocationProps} from './types';

const {locationSelected, change} = translations['pt-br'].commons;

export function CurrentLocation({shouldNavigateTo, dataTagId}: CurrentLocationProps) {
	const {palette} = useTheme();

	const {cdUfSelected, nmCidadeSelected} = useRequestAuthorization();

	return (
		<StyledStack id="header" direction="row" justifyContent={'space-between'}>
			<Stack direction="row" gap={1} alignItems={'center'}>
				<Icon name="location-on-filled" size={24} color={palette.primary.main} />
				<Stack>
					<Typography variant="caption" color="text.secondary">
						{locationSelected}
					</Typography>
					<Typography variant="subtitle2" color="primary" fontWeight={600}>
						{formatText(nmCidadeSelected)}/{cdUfSelected}
					</Typography>
				</Stack>
			</Stack>
			<StyledButton variant="text" onClick={shouldNavigateTo} data-tag-id={dataTagId}>
				{change}
			</StyledButton>
		</StyledStack>
	);
}
